var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KeyList',{attrs:{"title":_vm.FIELDS.COUNTRY,"placeholder":"Country","options":_vm.options,"disabled":_vm.isSaving,"showLabel":true,"defaultValue":_vm.country},on:{"value":_vm.setValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }